// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background-color: #F4F5FA;
  height: 100%;
  font-family: 'Actor', sans-serif;
}

html,
body,
#root {
  height: 100%;
  background-color: #F4F5FA;
}

/* Altura única para alinear header, sidebar y padding del área principal */
:root {
  --app-header-height: 60px;
}

#root {
  zoom: 80%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,2EAA2E;AAC3E;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX","sourcesContent":[".App {\n  text-align: center;\n  background-color: #F4F5FA;\n  height: 100%;\n  font-family: 'Actor', sans-serif;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  background-color: #F4F5FA;\n}\n\n/* Altura única para alinear header, sidebar y padding del área principal */\n:root {\n  --app-header-height: 60px;\n}\n\n#root {\n  zoom: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
